import React from 'react';

const PlanImpactLoadingView = () => (
  <div className="what-ifs-plan-impact-loading">
    <i />
  </div>
);

export default PlanImpactLoadingView;
